import { render, staticRenderFns } from "./DecisionIntelligence.vue?vue&type=template&id=99e72fcc&scoped=true"
import script from "./DecisionIntelligence.vue?vue&type=script&lang=js"
export * from "./DecisionIntelligence.vue?vue&type=script&lang=js"
import style0 from "./DecisionIntelligence.vue?vue&type=style&index=0&id=99e72fcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99e72fcc",
  null
  
)

export default component.exports